// extracted by mini-css-extract-plugin
var _1 = "QQGSK";
export { _1 as "error" }
